import React from 'react'
import { formatBigMoney } from '../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'
import { NewsItem } from 'types/NewsItem'

export const NewsHeadlineConversion = ({ row }: { row: NewsItem }) => {
    const { i18n, t } = useTranslation()
    const locale = i18n.language
    const { convertibleData, companyName, currency } = row

    return (
        <span>
            {t('pages.news.headlines.conversion.toShares', {
                companyName,
                amount: formatBigMoney(convertibleData.conversionAmount as number, { currencySymbol: currency, locale }),
            })}
        </span>
    )
}
